import React from 'react';
import { MediaData } from '~admin/model/media-data';
import { MediaListImage } from '~admin/view/components/ui/form/fields/media/media-list/media-list-image.component';
import { MediaListVideo } from '~admin/view/components/ui/form/fields/media/media-list/media-list-video.component';
import { MediaType } from '~client/model/media-type';

interface Props {
  mediaType: MediaType;
  mediaList: MediaData[];
  onMediaSelected?: (media: MediaData) => void;
}

export const MediaPickerInnerSwitch: React.FunctionComponent<Props> = ({
  mediaType,
  mediaList,
  onMediaSelected,
}) => {
  switch (mediaType) {
    case MediaType.IMAGE:
    case MediaType.SEATMAP:
      return <MediaListImage mediaList={mediaList} onMediaSelected={onMediaSelected} />;
    case MediaType.VIDEO:
      return <MediaListVideo mediaList={mediaList} onMediaSelected={onMediaSelected} />;
    default:
      throw Error(`${mediaType} is not supported by the media picker.`);
  }
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-picker-inner-switch.component.tsx